import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { BuyerPoint } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type BuyerPointResponse = BuyerPoint;

export interface PointDataSource {
  getBuyerPoint(): Promise<BuyerPointResponse>;
}

export class PointDataSourceImpl implements PointDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getBuyerPoint() {
    return this.client.request<BuyerPointResponse>({
      url: '/api/market-place/v1/buyer/point',
      method: 'get',
    });
  }
}

export const pointDataSource = new PointDataSourceImpl();
